module.exports = __webpack_public_path__ + "img/nav-right-with-contact-toyota.54490396.png";